import ACTION_TYPES from '../actions/actionTypes'


export default (state, action) => {

    switch (action.type) {

        case ACTION_TYPES.FETCH_SBG_LOCATIONS:
            return { ...state, siteLocations: action.payload, locationList: action.payload };
        case ACTION_TYPES.SET_LOCATION_LIST:
            return { ...state, locationList: action.payload }
        case ACTION_TYPES.GET_USER_DATA:
            return { ...state, userData: action.payload }
        case ACTION_TYPES.UPDATE_PIN_SITE:
            return { ...state, pinSiteStatus: action.payload }
        case ACTION_TYPES.FETCH_TIERS:
            return { ...state, tiers: action.payload }
        case ACTION_TYPES.FETCH_TEMPLATE:
            return { ...state, template: action.payload }
        case ACTION_TYPES.FETCH_TABLEUA_DATA:
            return { ...state, tableuaData: action.payload }
        case ACTION_TYPES.GET_TIER_INFO:
            return { ...state, tierInfo: action.payload }
        case ACTION_TYPES.UPDATE_TEMPLATE_LOCAL:
            return { ...state, template: action.payload }
        case ACTION_TYPES.GET_USER_BY_CODE:
            return { ...state, userInfoByCode: action.payload }
        case ACTION_TYPES.UPDATE_TEMPLATE:
            return { ...state, isTemplateUpdate: new Date() }
        case ACTION_TYPES.PREVIEW:
            return { ...state, isPreview: new Date() }
        case ACTION_TYPES.FETCH_PINNED_SITES:
            return { ...state, pinnedSites: action.payload }
        case ACTION_TYPES.GET_SESSION_INFO:
            return { ...state, sessionInfo: action.payload }
        case ACTION_TYPES.VALIDATE_SESSION:
            return { ...state, validateSession: action.payload }
        case ACTION_TYPES.FETCH_KCATEGORY:
            return { ...state, kcategories: action.payload }
        case ACTION_TYPES.QUICK_LINK_INFO:
            return { ...state, quickLinkInfo: action.payload }
        case ACTION_TYPES.FETCH_SITE_INFO:
            return { ...state, siteInfo: action.payload }
        case ACTION_TYPES.SAVE_LAYOUT_FILE:
            return { ...state, layoutFileInfo: action.payload }
        case ACTION_TYPES.FETCH_CATEGORY_SAVE:
            return { ...state, categorySave: action.payload }
        case ACTION_TYPES.FETCH_KRECOG:
            return { ...state, recognition: action.payload }
        case ACTION_TYPES.FETCH_PUBLISHED_TPL:
            return { ...state, publishedTpl: action.payload }
        case ACTION_TYPES.FETCH_WB_INFO:
            return { ...state, wbData: action.payload }
        case ACTION_TYPES.GET_TABLEUA_INFO:
            return { ...state, tableuaInfo: action.payload }
        case ACTION_TYPES.GET_USER_HIGHEST_TIER:
            return { ...state, userHighestTier: action.payload }
        case ACTION_TYPES.GET_SITE_HIGHEST_TIER:
            return { ...state, siteHighestTier: action.payload }
        case ACTION_TYPES.GET_IMAGE:
            return { ...state, base64Image: action.payload }
        case ACTION_TYPES.GET_USER_DATA_ACCESS:
            return { ...state, userDetailsAppaccess: action.payload }
        case ACTION_TYPES.USERINFO_DETAILS:
            return { ...state, userProfile: action.payload }
        case ACTION_TYPES.GET_USER_DATA_ACCESS:
            return { ...state, userDetailsAppaccess: action.payload }
        case 'FETCH_SUB_TIERS':
            return { ...state, subTiers: action.payload }
            
        default:
            return state;
    }
};